<div class="flex items-center gap-2">
  <button
    type="button"
    class="flex items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
    (click)="toggleCritical()"
    [ngClass]="{
      'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': isCriticalEnabled(),
      'border-primary-blue bg-background-white': !isCriticalEnabled()
    }"
  >
    <span class="typo-h7-semibold">{{ 'health_history_filter_critical_label' | translate }}</span>
  </button>
  <button
    type="button"
    class="flex items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
    (click)="toggleActive()"
    [ngClass]="{
      'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': isActiveEnabled(),
      'border-primary-blue bg-background-white': !isActiveEnabled()
    }"
  >
    <span class="typo-h7-semibold">{{ 'health_history_filter_active_label' | translate }}</span>
  </button>
  <button
    type="button"
    class="flex items-center justify-center self-stretch overflow-hidden rounded-[8px] border px-2 py-1 text-primary-blue transition-colors"
    (click)="toggleInactive()"
    [ngClass]="{
      'border-primary-blue-pressed bg-primary-blue-pressed text-text-white': isInactiveEnabled(),
      'border-primary-blue bg-background-white': !isInactiveEnabled()
    }"
  >
    <span class="typo-h7-semibold">{{ 'health_history_filter_inactive_label' | translate }}</span>
  </button>
  <span class="typo-h7-light ml-1 text-text-tertiary">
    {{ 'health_history_filter_showing_count' | translate: { input1: visibleCount(), input2: totalCount() } }}
  </span>
</div>
